import api from './api';

const rsvpService = {
  // Create RSVP for an event
  createRSVP: async (eventId, rsvpData) => {
    const response = await api.post(`/events/${eventId}/rsvp`, rsvpData);
    return response.data;
  },

  // Get user's RSVPs
  getUserRSVPs: async (filters = {}) => {
    const response = await api.get('/my-rsvps', { params: filters });
    return response.data;
  },

  // Get single RSVP by ID
  getRSVPById: async (rsvpId) => {
    const response = await api.get(`/rsvps/${rsvpId}`);
    return response.data;
  },

  // Cancel RSVP
  cancelRSVP: async (rsvpId, reason = '') => {
    const response = await api.delete(`/rsvps/${rsvpId}`, {
      data: { reason }
    });
    return response.data;
  },

  // Admin: Get event attendees
  getEventAttendees: async (eventId, filters = {}) => {
    const response = await api.get(`/events/${eventId}/attendees`, { params: filters });
    return response.data;
  },

  // Admin: Update RSVP
  updateRSVP: async (rsvpId, updateData) => {
    const response = await api.put(`/rsvps/${rsvpId}`, updateData);
    return response.data;
  },

  // Admin: Check in attendee
  checkInAttendee: async (rsvpId) => {
    const response = await api.post(`/rsvps/${rsvpId}/checkin`);
    return response.data;
  },

  // Admin: Bulk delete RSVPs
  bulkDeleteRSVPs: async (rsvpIds, eventId) => {
    const response = await api.post('/rsvps/bulk-delete', {
      rsvpIds,
      eventId
    });
    return response.data;
  },

  // Admin: Export attendees to CSV
  exportAttendees: async (eventId, filters = {}) => {
    const response = await api.get(`/events/${eventId}/attendees/export`, {
      params: filters,
      responseType: 'blob' // Important for file download
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `attendees-${eventId}-${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'Export completed successfully' };
  },

  // QR Code: Get QR code for an RSVP
  getQRCode: async (rsvpId) => {
    const response = await api.get(`/rsvps/${rsvpId}/qr`);
    return response.data;
  },

  // QR Code: Verify QR code and check in
  verifyQRCode: async (qrCodeData) => {
    const response = await api.post('/rsvps/verify-qr', { qrCodeData });
    return response.data;
  },

  // QR Code: Regenerate QR code (Admin)
  regenerateQRCode: async (rsvpId) => {
    const response = await api.post(`/rsvps/${rsvpId}/regenerate-qr`);
    return response.data;
  },

  // Helper: Format RSVP status
  formatStatus: (status) => {
    const statusMap = {
      pending: 'Pending Approval',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      attended: 'Attended',
      waitlisted: 'Waitlisted'
    };
    return statusMap[status] || status;
  },

  // Helper: Get status color
  getStatusColor: (status) => {
    const colorMap = {
      pending: 'warning',
      confirmed: 'success',
      cancelled: 'error',
      attended: 'info',
      waitlisted: 'default'
    };
    return colorMap[status] || 'default';
  }
};

export default rsvpService;
